window.addEventListener('load', function() {
  $('#loginBtn').on('click', function() {
    if ($('#saveEmail').prop('checked')) {
      var email = $('#CustomerEmail').val();

      // 10日間
      document.cookie = 'userEmail=' + encodeURIComponent(email) + '; expires=' + new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000).toUTCString() + '; path=/';
    }
  });

  var storedEmail = getCookie('userEmail');
  if (storedEmail) {
    $('#CustomerEmail').val(decodeURIComponent(storedEmail));
  }

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }
});
